import { NoticeFirstOptionsType } from './types';

export const NOTICE_FIRST_OPTIONS: NoticeFirstOptionsType = [
  { id: 'body', title: '💪 Body' },
  { id: 'vibe', title: '✨ Vibe' },
  { id: 'style', title: '😎 Style' },
  { id: 'eyes', title: '👁 Eyes' },
  { id: 'confidence', title: '💎 Confidence' },
];
